import { render, staticRenderFns } from "./music.vue?vue&type=template&id=57b26f77&scoped=true&"
import script from "./music.vue?vue&type=script&lang=js&"
export * from "./music.vue?vue&type=script&lang=js&"
import style0 from "./music.vue?vue&type=style&index=0&id=57b26f77&prod&lang=less&scoped=true&"
import style1 from "./music.vue?vue&type=style&index=1&id=57b26f77&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b26f77",
  null
  
)

export default component.exports